module.exports = __webpack_public_path__ + "static/media/bot-bg.a6f7af04.png";